const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const token = () => localStorage.getItem('token') || localStorage.getItem('vincentrix_token') || '';
const headers = () => ({
  'Content-Type': 'application/json',
  ...(token() ? { Authorization: `Bearer ${token()}` } : {})
});
const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const usd = value => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:0}).format(Number(value)||0);
const pct = value => `${Number(value || 0).toFixed(1)}%`;

let payload = null;
let timer = null;
let observer = null;

const card = (label,value,sub='') => `<div class="vc-roi-card"><div class="vc-roi-label">${esc(label)}</div><div class="vc-roi-value">${esc(value)}</div>${sub?`<div class="vc-roi-sub">${esc(sub)}</div>`:''}</div>`;

const stageCount = (summary, stage) => Number(summary?.stages?.[stage] || 0);

const ensureLayout = () => {
  if (document.getElementById('vc-os-layout')) return;
  const style = document.createElement('style');
  style.id = 'vc-os-layout';
  style.textContent = `
    .vc-os-sydney-grid{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:10px;padding:14px}
    .vc-os-stage-strip{display:grid;grid-template-columns:repeat(7,minmax(0,1fr));gap:8px;padding:0 14px 14px}
    .vc-os-stage{padding:10px;border-radius:11px;background:rgba(255,255,255,.035);border:1px solid rgba(255,255,255,.075)}
    .vc-os-stage-label{font-size:8px;text-transform:uppercase;letter-spacing:.8px;color:rgba(255,255,255,.42);font-weight:800}
    .vc-os-stage-value{font-size:17px;font-weight:900;margin-top:4px}
    @media(max-width:900px){.vc-os-sydney-grid{grid-template-columns:repeat(3,1fr)}.vc-os-stage-strip{grid-template-columns:repeat(3,1fr)}}
    @media(max-width:560px){.vc-os-sydney-grid,.vc-os-stage-strip{grid-template-columns:repeat(2,1fr)}}
  `;
  document.head.appendChild(style);
};

const render = () => {
  const workspace = document.querySelector('.vc-acquisition-workspace');
  if (!workspace || !payload?.summary) return;
  ensureLayout();
  const s = payload.summary;
  const sy = s.sydney || {};

  let gm = document.getElementById('vc-os-gm-snapshot');
  if (!gm) {
    gm = document.createElement('section');
    gm.id = 'vc-os-gm-snapshot';
    gm.className = 'vc-roi-wrap';
    const today = document.getElementById('vc-acquisition-today');
    if (today?.nextSibling) workspace.insertBefore(gm,today.nextSibling); else if (today) workspace.appendChild(gm); else workspace.prepend(gm);
  }
  gm.innerHTML = `
    <div class="vc-roi-head"><div><div class="vc-roi-kicker">ACQUISITION OPERATING SYSTEM</div><div class="vc-roi-title">GM Snapshot</div><div class="vc-roi-note">What the acquisition operation is producing right now.</div></div><button class="vc-roi-refresh" data-os-refresh>Refresh</button></div>
    <div class="vc-roi-grid">
      ${card('Active Opportunities',s.active,`${s.dueNow||0} due now`)}
      ${card('Acquired This Month',s.acquiredThisMonth,`${s.acquiredAllTime||0} all time`)}
      ${card('Acquisition Conversion',pct(s.conversionRate))}
      ${card('Realized Gross',usd(s.realizedGross),`${s.sold||0} acquired vehicles sold`)}
      ${card('Avg Days to Sell',s.avgDaysToSell ?? '—',`${usd(s.avgGross)} avg gross`)}
    </div>
    <div class="vc-os-stage-strip">
      ${[['Identified','identified'],['Contacting','contacting'],['Engaged','engaged'],['Needs Appraisal','appraisal-needed'],['Offer Made','offer-made'],['Appointment','appointment'],['Pending','acquisition-pending']].map(([label,key])=>`<div class="vc-os-stage"><div class="vc-os-stage-label">${label}</div><div class="vc-os-stage-value">${stageCount(s,key)}</div></div>`).join('')}
    </div>`;

  let syd = document.getElementById('vc-os-sydney-snapshot');
  if (!syd) {
    syd = document.createElement('section');
    syd.id = 'vc-os-sydney-snapshot';
    syd.className = 'vc-rp-wrap';
    gm.insertAdjacentElement('afterend',syd);
  }
  syd.innerHTML = `
    <div class="vc-rp-head"><div><div class="vc-rp-kicker">SYDNEY</div><div class="vc-rp-title">AI Acquisition Coordinator</div><div class="vc-rp-note">Activity generated from this rooftop's actual acquisition records and conversations.</div></div></div>
    <div class="vc-os-sydney-grid">
      ${card('Screened',sy.screened||0)}
      ${card('Conversations Started',sy.conversationsStarted||0)}
      ${card('Customer Replies',sy.customerReplies||0)}
      ${card('Interested',sy.interested||0)}
      ${card('Appointments',sy.appointments||0)}
      ${card('Manager Escalations',sy.managerEscalations||0)}
    </div>`;

  document.querySelectorAll('[data-os-refresh]').forEach(button => button.onclick = refresh);
};

const refresh = async () => {
  if (!document.querySelector('.vc-acquisition-workspace')) return;
  try {
    const response = await fetch(`${API_URL}/api/acquisition-os/overview`,{headers:headers()});
    if (!response.ok) throw new Error(`Acquisition OS ${response.status}`);
    payload = await response.json();
    render();
  } catch (error) {
    console.warn('Acquisition OS dashboard refresh failed:',error);
  }
};

const boot = () => {
  observer = new MutationObserver(() => {
    if (document.querySelector('.vc-acquisition-workspace') && !document.getElementById('vc-os-gm-snapshot')) refresh();
  });
  observer.observe(document.body,{childList:true,subtree:true});
  timer = setInterval(() => { if (document.visibilityState === 'visible') refresh(); },60000);
  window.addEventListener('focus',refresh);
  window.addEventListener('beforeunload',()=>{clearInterval(timer);observer?.disconnect();});
  refresh();
};

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();